'use client';

import React from 'react';
import { useTina } from 'tinacms/dist/react';
import {
  type ContentQueryQuery,
  type ContentQueryQueryVariables,
} from '@/tina/__generated__/types';
import { Preview } from '@/app/(base)/components/preview';
import { PageContent } from '@/app/(base)/[slug]/components/page-content';

function PagePreview(props: {
  data: ContentQueryQuery;
  query: string;
  variables: ContentQueryQueryVariables;
}): React.JSX.Element {
  const { data } = useTina<ContentQueryQuery>({
    query: props.query,
    variables: props.variables,
    data: props.data,
  });

  return (
    <>
      <Preview />
      <PageContent data={data} />
    </>
  );
}

export { PagePreview };
